import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowReference } from "../../../common/controls";
import { ShowMultiLine } from "../../../common/controls";
import { ShowBoolean } from "../../../common/controls";
import { ShowNumber } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type TenantLlmConfigViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  providerValue: { displayId: string; id: string } | null;
  modelValue?: { displayId: string; id: string } | null;
  model: string;
  baseUrlValue?: { displayId: string; id: string } | null;
  baseUrl: string;
  enabledValue?: { displayId: string; id: string } | null;
  enabled: boolean;
  priorityValue?: { displayId: string; id: string } | null;
  priority: number;
  maxTokensValue?: { displayId: string; id: string } | null;
  maxTokens: number | undefined;
  temperatureValue?: { displayId: string; id: string } | null;
  temperature: number | undefined;
  debugFullModeValue?: { displayId: string; id: string } | null;
  debugFullMode: boolean;
};

export const TenantLlmConfigViewForm: React.FC<TenantLlmConfigViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      providerValue,
      model = "",
      baseUrl = "",
      enabled = false,
      priority = 0,
      maxTokens = 0,
      temperature = 0,
      debugFullMode = false,
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupTenantLlmConfigLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowReference
                  label={langStore.TenantLlmConfigProviderLabel}
                  selectedValue={langStore.displayIdByLang(
                    providerValue?.displayId
                  )}
                />
                <ShowMultiLine
                  value={model}
                  label={langStore.TenantLlmConfigModelLabel}
                />

                <ShowMultiLine
                  value={baseUrl}
                  label={langStore.TenantLlmConfigBaseUrlLabel}
                />
                <ShowBoolean
                  value={enabled}
                  label={langStore.TenantLlmConfigEnabledLabel}
                />
                <ShowNumber
                  value={priority}
                  label={langStore.TenantLlmConfigPriorityLabel}
                />
                <ShowNumber
                  value={maxTokens}
                  label={langStore.TenantLlmConfigMaxTokensLabel}
                />
                <ShowNumber
                  value={temperature}
                  label={langStore.TenantLlmConfigTemperatureLabel}
                  decimalScale={2}
                />
                <ShowBoolean
                  value={debugFullMode}
                  label={langStore.TenantLlmConfigDebugFullModeLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
